import React from "react";
import * as XLSX from "xlsx";
import { t } from "i18next";
import withRouter from '../../../components/Common/withRouter'
import { withTranslation } from "react-i18next";

const ExportBudgetingExcel = ({ budgetings }) => {
  const handleExportExcel = () => {
    const worksheetData = [];
    const merges = [];
    const styles = [];

    let rowIndex = 0;

    //Titre dynamique basé sur l'année courante
    const currentYear = new Date().getFullYear();
    const previousYear = currentYear - 1;
    const title = `Budgeted income statement for ${previousYear} / ${currentYear} Financial year`;

    //Ligne de titre principale
    worksheetData.push([title]);
    merges.push({ s: { r: rowIndex, c: 0 }, e: { r: rowIndex, c: 5 } });
    styles.push({ r: rowIndex, bold: true });
    rowIndex++;

    //Ligne vide de séparation
    worksheetData.push([]);
    rowIndex++;

    Object.entries(budgetings).forEach(([key, rows]) => {
      if (!rows.length) return;

      const groupName = rows[0].parentName;
      const groupTitle = `Income from ${groupName}`;

      //Titre de groupe
      worksheetData.push([groupTitle]);
      merges.push({ s: { r: rowIndex, c: 0 }, e: { r: rowIndex, c: 5 } });
      styles.push({ r: rowIndex, bold: true });
      rowIndex++;

      //En-têtes
      worksheetData.push(["Account", "Description", "Budgeted", "Actual", "Variance", "Rate"]);
      styles.push({ r: rowIndex, bold: true });
      rowIndex++;

      let totalBudgeted = 0;
      let totalActual = 0;

      rows.forEach(row => {
        const actual = row.actualAmount || 0;
        const budgeted = row.budgetedAmount || 0;
        const variance = budgeted - actual;
        const rate = budgeted > 0 ? ((actual / budgeted) * 100).toFixed(2) + "%" : "0%";

        totalBudgeted += budgeted;
        totalActual += actual;

        worksheetData.push([
          row.account,
          row.description,
          budgeted,
          actual,
          variance,
          rate,
        ]);
        rowIndex++;
      });

      const totalVariance = totalBudgeted - totalActual;
      const totalRate = totalBudgeted > 0
        ? ((totalActual / totalBudgeted) * 100).toFixed(2) + "%"
        : "0%";

      // Ligne de total
      worksheetData.push([
        "Total",
        "-",
        totalBudgeted,
        totalActual,
        totalVariance,
        totalRate,
      ]);
      styles.push({ r: rowIndex, bold: true });
      rowIndex++;

      // Ligne vide
      worksheetData.push([]);
      rowIndex++;
    });

    // Crée la feuille
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

    //Applique les styles gras
    styles.forEach(style => {
      for (let c = 0; c <= 5; c++) {
        const cellRef = XLSX.utils.encode_cell({ r: style.r, c });
        if (!worksheet[cellRef]) continue;
        worksheet[cellRef].s = { font: { bold: true } };
      }
    });

    //Fusions
    worksheet["!merges"] = merges;

    //Colonnes auto-largueur
    worksheet["!cols"] = [
      { wch: 20 },
      { wch: 30 },
      { wch: 15 },
      { wch: 15 },
      { wch: 15 },
      { wch: 10 },
    ];

    // Création et téléchargement du fichier
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Budgeting");
    XLSX.writeFile(workbook, "budgeting_export.xlsx");
  };

   return (
      <button className="btn btn-success d-inline-flex align-items-center" onClick={handleExportExcel}>
        <i className="fa fa-file-excel me-1" /> {t("export_excell")}
      </button>
    )
};

export default withRouter(withTranslation()(ExportBudgetingExcel));
